import {
  colorTokens,
  getSpacing,
  typographyTokens,
} from "../../../designTokens";
import { getUniversalSearchShortcutLabel } from "./universalSearchShortcutUtils";

/**
 * Shortcut tip shown below the Universal Search modal.
 */
const UniversalSearchModalShortcutTip: React.FC = () => {
  const shortcutLabel = getUniversalSearchShortcutLabel().replace("+", " + ");

  return (
    <p
      id="search-patient-modal-shortcut-tip"
      aria-live="polite"
      style={{
        position: "absolute",
        top: `calc(100% + ${getSpacing("16px")})`,
        left: "50%",
        transform: "translateX(-50%)",
        margin: 0,
        padding: `${getSpacing("8px")} ${getSpacing("16px")}`,
        borderRadius: "999px",
        backgroundColor: colorTokens["Text/Black"],
        color: colorTokens["Background/White"],
        fontFamily: typographyTokens["Body/Small"].family,
        fontSize: `${typographyTokens["Body/Small"].size}px`,
        fontWeight: typographyTokens["Body/Small"].weight,
        lineHeight: typographyTokens["Body/Small"].lineHeight,
        whiteSpace: "nowrap",
      }}
    >
      Tip: Open this faster with {shortcutLabel}
    </p>
  );
};

export default UniversalSearchModalShortcutTip;
